module.exports = __webpack_public_path__ + "static/og-image-playground-400e6ebcb8c1987456dad6b63b9dc115.png";